@if (data.title) {
  <h1 mat-dialog-title>{{ data.title }}</h1>
}

<mat-dialog-content>
  @if (data.description) {
    <p>{{ data.description }}</p>
  }

  @for (input of data.inputs; track $index; let i = $index) {
    <mat-form-field appearance="outline">
      <mat-label>{{ input.label }}</mat-label>
      <input
        matInput
        (keydown.enter)="submit()"
        [ngModel]="value[input.slug]"
        (ngModelChange)="value[input.slug] = $event"
        [type]="input.type ?? 'text'"
        [placeholder]="input.placeholder ?? ''"
        [required]="input.required ?? false"
      />
    </mat-form-field>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="accent" (click)="submit()">{{ data.close_button_text }}</button>
</mat-dialog-actions>
